import { useState } from "react";
import Form from "react-bootstrap/Form";

export const Subscribe = () => {
  const [SenderFirstName, setSenderFirstName] = useState("");
  const [SenderLastName, setSenderLastName] = useState("");
  const [SenderEmail, setSenderEmail] = useState("");
  const [SenderMessage, setSenderMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
  };
  return (
    <div className="subscribe_container mb-2 py-3 py-lg-5 ">
      <div className="container d-flex flex-column align-items-center">
        <h2 className="text-white pt-4 mb-4">Contact Us</h2>
        <p className="text-white mb-5">Having any issue feel free to contact Us.</p>
        <div className="contact_form_container w-100">
      <form onSubmit={handleSubmit}>
        <div className="form-group mb-4">
          <Form.Group>
            <input
              type="text"
              className="form-control bg-transparent text-white text-center btn_form"
              id="exampleInputname"
              placeholder="Enter Your First Name"
              value={SenderFirstName}
              onChange={(e) => setSenderFirstName(e.target.value)}
            />
          </Form.Group>
        </div>
        <div className="form-group mb-4">
          <Form.Group>
            <input
              type="text"
              className="form-control bg-transparent text-white text-center btn_form"
              id="exampleInputname"
              placeholder="Enter Your Last Name"
              value={SenderLastName}
              onChange={(e) => setSenderLastName(e.target.value)}
            />
          </Form.Group>
        </div>
        <div className="form-group mb-4">
          <Form.Group>
            <input
              type="email"
              className="form-control bg-transparent text-white text-center btn_form"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              placeholder="Enter Your Email"
              value={SenderEmail}
              onChange={(e) => setSenderEmail(e.target.value)}
            />
          </Form.Group>
        </div>
        <div className="form-group mb-4">
          <Form.Group>
            <textarea
              type="email"
              className="form-control bg-transparent text-white text-center btn_form"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              placeholder="Enter Message Here"
              rows="6"
              value={SenderMessage}
              onChange={(e) => setSenderMessage(e.target.value)}
            ></textarea>
          </Form.Group>
        </div>
        <button
          type="submit"
          className="custom_Button w-50"
        >
          Click to Submit
        </button>
      </form>
    </div>
      </div>
    </div>
  );
};
